<template>
  <div class="procard_wrap">
   
    <h1 class="telMeH1">联系我们</h1>
    <div class="grayTxt bounce-element1">
      CONTACT US
    </div>
    
    <div class="procard_content" >
      <div class="content_left">
        <div class="left_tit">
          联系我们
          <!-- <img src="../../assets/img3/lianxiwomen/1.png"  /> -->
        </div>
        <ul class="contactUl">
						<li style=" user-select: none;">
							<span>
								<i class="el-icon-location-information"></i>地址:
							</span>
							<span>
								郑州市经济开发区航海东路1511号
							</span>
						</li>
						<li style=" user-select: none;">
							<span>
								<i class="el-icon-phone-outline"></i>电话、传真:
							</span>
							<span>
                0371-65959666
							</span>
						</li>
						<li style=" user-select: none;">
							<span>
								<i class="el-icon-message"></i>电子邮箱:
							</span>
							<span>
								hngwjt@zygangwu.com
							</span>
						</li>
					</ul>
      
        
      </div>
      <div class="content_right" >
        <a target="_blank" class="mapA" href="https://map.baidu.com/poi/%E6%B2%B3%E5%8D%97%E4%B8%AD%E8%B1%AB%E5%9B%BD%E9%99%85%E6%B8%AF%E5%8A%A1%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8-%E5%8C%97%E9%97%A8/@12666156.10877015,4102134.7750731,19z?uid=a667f5b76a70509b28201ac4&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl">
          <img src="../../assets/w/img3/gaikuang/guaikuang-map.jpg" alt="" :style="{ width: 'auto', height: '90%', objectFit: 'cover' }" />
        </a>
      </div>
    </div>

    <div style="width: 90vw;margin:0 auto;"> 
      <a href="/leaderEmail?type=0" > 
        <img src="../../assets/8.4/jiaoliuxinxiang.png" style="width: 90vw !important;height: auto;" />
      </a>
    </div>

    <h1 class="telMeH1 telMeH2">业务板块联系信息</h1>



    <!-- 联系方式列表信息移动端 -->
    <div class="MobileTelmsg">
      <div class="MobileTelmsgDiv"> 
        <span v-for="(item,index) in titleList" :key="item.id" :class="cardId==item.remarks?'activeTab':''" @click="changetTab(item,index)">{{ item.explains }}</span>
      </div>
      <ul class="ulMsg">
        <li class="liMsg" v-for="(item,index) in contactList" :key="index" >
          <ul>
            <li> 名称：{{ item.company }}</li>
            <li> 联系人：{{ item.name }}</li>
            <li> 联系方式：{{ item.phone }}</li>
            <li> 邮箱：{{ item.email }}</li>
            <li> 地址：{{ item.address }}</li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="tabDivContainer"> 
      <div class="tabDiv">
        <!-- <span>中欧班列</span>
        <span>现代物流</span>
        <span class="activeTab">运贸产融合</span>
        <span>海外布局</span>
        <span>开发建设</span> -->
        <span v-for="(item,index) in titleList" :key="item.id" :class="cardId==item.remarks?'activeTab':''" @click="changetTab(item,index)">{{ item.explains }}</span>
      </div>
    </div>
    
  
    
    <el-table
      class="lianxiwomen"
        :data="contactList"
        stripe
        :row-class-name="tableRowClassName">
        <el-table-column
            prop="company"
            label="名称"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="联系人"
           
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系方式"
           >
            <template slot-scope="scope">
               <ul>
                <li v-for="item in scope.row.phone.split('/')" :key="item">
                  {{ item }}
                </li>
               </ul>
            </template>
          </el-table-column>
          <el-table-column
            prop="email"
            label="邮箱"
            >
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址">
          </el-table-column>
    </el-table>
     

     
    
  </div>
</template>

<script>
import API from '@/api/index'


export default {
  components: {
  
  },
  data() {
    return {
      activeTabNum:0,
      cardId:null,
      titleList:[],
      contactList:[],
    
      
    }
  },
  props: {
   
  },
  mounted(){
    this.getList()
   
  },
  methods: {
   changetTab(item,index){
    if(this.cardId == item.remarks){
      this.activeTabNum = null;
      this.cardId=null
      this.getList()
   
    }else{
      this.activeTabNum = index;
      this.cardId=item.remarks
      this.getList2()
   
    }
   
   },
   //获取初始化数据
    async getList() {
      try {
        let objParams={
          catId:'9e6274e05d4e40438c4a357704e3c56d'
        }
        const res = await API.telList(objParams)
        this.titleList=res.data.titleList
       
        // this.cardId=this.titleList[0].remarks
        this.contactList=res.data.contactList
        console.log('获取成功', res.data.resultData)
      } catch (error) {
        console.error('获取失败', error)
      }
    },

    
    //获取初始化数据
    async getList2() {
      try {
        let objParams={
          businessId:this.cardId
        }
        const res = await API.tel2List(objParams)
        this.contactList=res.data.contactList
        console.log('获取成功', res.data.resultData)
      } catch (error) {
        console.error('获取失败', error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
ul li{
  list-style: none;
}
.procard_wrap {
  width: 90vw;
  // border: 2px solid #000;
  margin:0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;
  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
  }
  .procard_btn {
    width: 100%;
    display: flex;
    .procard_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }
    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;
      &::before {
        // content: '▲';
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }
  .procard_content {
    width: 90vw;
    display: flex;
    padding: 30px 0;
    // justify-content: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
    .content_right {
      // background: blue;
      width:65%;
      
      overflow: hidden; 
      margin-left: 1rem;
       @media screen and (max-width: 768px) {
        width: 100%;
              margin-left: 0rem;

      }
      .mapA{
        width: 100%;
        height: 100%;
        display:block;
       
        // border:1px solid #999999;
        cursor:pointer;
      
        img{
          width: 100%;
          height: 100% !important;
        }
      }
      .mapA:hover{
              // border:1px solid #ebecec;
              transition: transform 7.5s ease;
              transform: scale(1.2); /* 放大1.1倍 */
      }
      
     
    }
    .content_left {
      width: 35%;
      // margin-left: 5%;
      // background: red;
      padding:0 3vw;
      font-size: 1rem;
      line-height: 3rem;
      background: #015293;
      color: #fff;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      text-align: left;
      .left_tit{
        font-size: 2rem;
        line-height: 6rem;
        padding-top:1rem;
        border-bottom: 1px solid #ffffff;
        img{
          width: 100%;
        }
      }
      .contactUl{
        width: 100%;
        padding-top:1.5rem;
        li{
          list-style: none;
          line-height:3rem;
          font-size:1rem;
          @media screen and (max-width: 768px) {
            font-size:1rem;
            line-height:2rem;
          }
        }
      }
      .left_txt{
        text-indent: 2em;
        line-height:2em;
        @media screen and (max-width: 768px) {
          line-height:3em;
          text-align: left;
      }
      }
    }
  }
}
.telMeH1{
  line-height: 7rem;
  font-size: 2rem;
  color: #222;
  font-weight: normal;
}
.telMeH2{
  // margin-top:1rem;
}
.grayTxt{
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  // padding-top: 0.5rem;
  color: #eee !important;
}
.tabDivContainer{
  width: 100vw;
}
 .MobileTelmsg{
     display: none;
  }
@media screen and (max-width: 768px) {
  .tabDivContainer,.lianxiwomen{
    display: none;
  }
  .MobileTelmsg{
     display: block;
     .MobileTelmsgDiv{
      margin-bottom: 1rem;
      background: #eee;
      padding:1rem 0;
      padding-left: 3vw;
      span{
       display: inline-block;
       width: 23vw;
       text-align: left;
       font-size: 1.2rem;
       color: #333;
      }
      span.activeTab{
        color:#015293
      }
     }
  }
  .ulMsg{
    padding:1rem;
    li.liMsg{
      margin-bottom: 1rem;
      border:1px solid #015293;
      padding:1rem;
    }
  }
}

.tabDiv{
  width: 90vw;

  margin:0 auto;
  display: flex;
  text-align: center;
   gap: 1rem;
  justify-content: center; /* 网格整体水平居中 */
  @media screen and (max-width: 768px) {
        flex-direction: column;     
  }

  span{
    padding:0 1.8rem;
    text-align: center;
    line-height: 3rem;
    cursor: pointer;
  }
  .activeTab{
    // font-weight: bolder;
    color: #015293;
    border-radius: 3rem;
    border:1px solid #2091d3;
  }
  // .activeTab1{
  //   color: #015293;
  //   font-weight: bold;
  //   border-bottom:1px solid #2091d3;
  // }
}
.contentDiv{
  // width: 90vw;
  // margin: 0 auto;
  // border: 2px solid #cd0404;
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4列等宽 */
  gap: 1vw; /* 统一行列间距 */
  width: 90vw; /* 铺满父容器 */
   
  .itemContentDiv{
    width: 21vw;
    // background: green;

    // background: red;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
    ul{
      width: 100%;

      li{
        width: 100%;
        list-style: none;
        line-height: 2rem !important;
        text-indent:0 !important;
        padding:0 0.5rem;
        text-align: left !important;
      
      }
      li.grayLi{
       background: #e5edf4;
        color: #222;
        font-weight: bold;
        height: 4rem;
        line-height: 4rem !important;
      }
      li.telLi{
        // padding-top: 1rem;
        /* 首选方案：保持电话号码在同一行 */
        // white-space: nowrap;
        // white-space: normal;
        // word-break: keep-all; /* 尽量保持数字完整 */
      }
      li.emailLi{

      }
      li.addressLi{
        padding-bottom: 1rem;
      }
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr); /* 4列等宽 */ 
    .itemContentDiv{
      width: 90vw;
    }
  }
}
::v-deep{
  .el-table{
     .cell{
      line-height:2rem;
     }
  }
}


</style>